import React from "react";
import { Bell } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/popover";
import { Button } from "src/components/ui/button";
import { Badge } from "src/components/ui/badge";
import { Separator } from "src/components/ui/separator";
import { formatDistanceToNow } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../context/NotificationContext";
import { toast } from "sonner";
import { Skeleton } from "src/components/ui/skeleton";
import { useAuth } from "../../../context/AuthContext";

const NotificationBell = () => {
  const { user } = useAuth();
  const { notifications, loadingNotifications, markAsRead } = useNotification();
  const navigate = useNavigate();

  // Filter unread notifications
  const unreadNotifications = notifications.filter(
    (notification) => notification.is_read === 0
  );

  const navigateUrl =
    user?.role === "admin"
      ? "/admin/notifications"
      : user?.role === "teacher"
      ? "/teacher/notifications"
      : "notifications";

  const handleViewAll = () => {
    navigate(navigateUrl);
  };

  const handleMarkAllAsRead = () => {
    // markAllAsRead();
    toast.success("All notifications marked as read");
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          {unreadNotifications.length > 0 && (
            <Badge className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center rounded-full bg-red-500 hover:bg-red-400 text-white p-0">
              {unreadNotifications.length}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-medium text-sm">Notifications</h4>
          {/* {unreadCount > 0 && (
            <Button
              variant="ghost"
              size="sm"
              className="text-xs hover:bg-secondary"
              onClick={handleMarkAllAsRead}
            >
              Mark all as read
            </Button>
          )} */}
        </div>

        <Separator className="my-2" />

        <div className="h-[300px] over">
          {loadingNotifications ? (
            <div className="space-y-4">
              <Skeleton className="w-full h-20" />
              <Skeleton className="w-full h-20" />
              <Skeleton className="w-full h-20" />
            </div>
          ) : unreadNotifications.length > 0 ? (
            unreadNotifications.map((notification) => (
              <div key={notification.id} className="mb-3 last:mb-0">
                <div className="flex items-start justify-between">
                  <div>
                    <h5 className="font-medium text-sm">
                      {notification.title}
                    </h5>
                    <p className="text-xs text-muted-foreground">
                      {notification.message}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {formatDistanceToNow(new Date(notification.created_at), {
                        addSuffix: true,
                      })}
                    </p>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-xs h-6"
                    onClick={() => markAsRead(notification.id)}
                  >
                    Mark read
                  </Button>
                </div>
                <Separator className="my-2" />
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center h-full py-8 text-center">
              <p className="text-sm text-muted-foreground">
                No new notifications
              </p>
            </div>
          )}
        </div>

        <Separator className="my-2" />
        <div className="flex justify-center mt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleViewAll}
            className="w-full"
          >
            View all notifications
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default NotificationBell;
